export default __webpack_public_path__ + "static/media/fauna-docs-code-styling.68c590df.png";